import { css } from 'styled-components';

export const cardBorder = css`
  border-radius: 0.4rem;
  box-shadow: 0 0 2px 0 rgba(0,0,0,0.14), 0 2px 2px 0 rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.2);
`;
